module.exports = __webpack_public_path__ + "img/distributor.b40022b8.png";